import { render, staticRenderFns } from "./wxRedirect.vue?vue&type=template&id=0c760a38&scoped=true"
import script from "./wxRedirect.vue?vue&type=script&lang=js"
export * from "./wxRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c760a38",
  null
  
)

export default component.exports